export default {"src":"/_next/static/media/bg-right.b050c64a.svg","height":544,"width":626,"blurWidth":0,"blurHeight":0};